import Text from '@root/components/v2/ui-elements/Text';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';

export const workloadVulSideoverlayColumns = selectedRow => {
  return [
    {
      field: 'layerID',
      headerName: 'Layer ID',
      width: 250,
      renderCell: params => {
        return (
          <Tooltip title={params.row.layerID}>
            <Text fontWeight={500} className="SingleLine">
              {params.row.layerID}
            </Text>
          </Tooltip>
        );
      },
    },
    {
      field: 'path',
      headerName: 'Path',
      width: 250,
      renderCell: params => {
        return (
          <Tooltip title={params.row.path}>
            <Text fontWeight={500} className="SingleLine">
              {params.row.path}
            </Text>
          </Tooltip>
        );
      },
    },
    {
      field: 'in_use',
      headerName: 'In Use',
      width: 200,
      renderCell: () => {
        return (
          <Text fontWeight={500} className="SingleLine">
            {selectedRow?.in_use ? 'True' : 'False'}
          </Text>
        );
      },
    },
  ];
};
